<template>
<div>
    <div class="content">
        <div class="cont-list">
            <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        </div>
        <div class="header">
            <div class="left">
                <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
            </div>
        </div>

        <el-tabs v-model="query.type" @tab-click="handleClick">
            <el-tab-pane label="其它供应商维护" name="0">

                <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
                    <template slot="empty">
                        <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                            <img src="../../../../assets/noData.png" width="240" height="240" />
                            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                            <div class="empty-rest" @click="reset">恢复默认</div>
                        </div>
                    </template>

                    <el-table-column prop="no" label="授权链编号" min-width="150">
                      <template slot-scope="scope">
                        <span>
                          <el-link type="primary" @click="viewEvt(scope.row,1)">{{ scope.row.no?scope.row.no:'-' }}</el-link>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="productName" label="逐级授权追溯" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div>
                                1 . {{ scope.row.manufacturerName }} {{parseTime(new Date(scope.row.startDate), '{y}-{m}-{d}')}}至{{parseTime(new Date(scope.row.endDate), '{y}-{m}-{d}')}}
                            </div>
                            <div v-for=" (item,index) in scope.row.details " :key="index">
                                {{ index+2  }}. {{ item.supplierName }} {{parseTime(new Date(item.startDate), '{y}-{m}-{d}')}}至{{parseTime(new Date(item.endDate), '{y}-{m}-{d}')}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productNo" label="有效授权期限 效期类型" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <p>{{parseTime(new Date(scope.row.startDate), '{y}-{m}-{d}')}}至{{parseTime(new Date(scope.row.endDate), '{y}-{m}-{d}')}}</p>
                            {{ scope.row.overdueName }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="categoryNo" label="授权产品 规格型号" min-width="120" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div v-for=" (item,index) in scope.row.products " :key="index">
                                {{ item.name }} {{ item.specName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="approveStateName" label="审批状态" min-width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.remark?scope.row.remark:'-' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="160">
                        <template slot-scope="scope">
                            <!-- <el-button type="text" v-preventReClick @click="viewEvt(scope.row,1)" class="color-blue">查看</el-button> -->
                            <el-button v-if="scope.row.approveState==0" type="text" v-preventReClick @click="viewEvt(scope.row,2)" class="color-blue">审批</el-button>
                            <el-button type="text" v-preventReClick @click="deleteEvt(scope.row)" class="color-blue">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="其它供应商" name="1">
                <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
                    <template slot="empty">
                        <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                            <img src="../../../../assets/noData.png" width="240" height="240" />
                            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                            <div class="empty-rest" @click="reset">恢复默认</div>
                        </div>
                    </template>
                    <el-table-column prop="no" label="授权链编号" min-width="80">
                      <template slot-scope="scope">
                        <span>
                          <el-link type="primary" @click="viewEvt(scope.row,1)">{{ scope.row.no?scope.row.no:'-' }}</el-link>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="productName" label="逐级授权追溯" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div>
                                1 . {{ scope.row.manufacturerName }} {{parseTime(new Date(scope.row.startDate), '{y}-{m}-{d}')}}至{{parseTime(new Date(scope.row.endDate), '{y}-{m}-{d}')}}
                            </div>
                            <div v-for=" (item,index) in scope.row.details " :key="index">
                                {{ index+2  }}. {{ item.supplierName }} {{parseTime(new Date(item.startDate), '{y}-{m}-{d}')}}至{{parseTime(new Date(item.endDate), '{y}-{m}-{d}')}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productNo" label="有效授权期限 效期类型" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <p>{{parseTime(new Date(scope.row.startDate), '{y}-{m}-{d}')}}至{{parseTime(new Date(scope.row.endDate), '{y}-{m}-{d}')}}</p>
                            {{ scope.row.overdueName }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="categoryNo" label="授权产品 规格型号" min-width="120" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div v-for=" (item,index) in scope.row.products " :key="index">
                                {{ item.name }} {{ item.specName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.remark?scope.row.remark:'-' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="operation" label="操作" width="100">
                        <template slot-scope="scope">
                            <!-- <el-button type="text" v-preventReClick @click="viewEvt(scope.row,1)" class="color-blue">查看</el-button> -->
                            <el-button type="text" v-preventReClick @click="deleteEvt(scope.row)" class="color-blue">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>

    </div>
    <div class="pagination">
        <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
        </el-pagination>
    </div>

    <el-dialog title="查看" :visible.sync="show" width="60%" :show-close="false" :close-on-click-modal="false" @close="bindingClose">
        <el-form :model="AuthorizeChainViewModel" label-width="80px" style="border: 1px solid #00000028; padding: 10px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="生产厂家" prop="manufacturerId">
                        <el-select disabled v-model="AuthorizeChainViewModel.manufacturerId" style="width: 100%" filterable placeholder="请选择" :style="{ width: '280px' }">
                            <el-option v-for="i in STATIC_Manufacturers" :key="i.id" :label="i.name" :value="i.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="授权期限" required>
                        <el-date-picker disabled v-model="AuthorizeChainViewModel.startDate" type="date" style="width:150px" placeholder="选择开始日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                        -
                        <el-date-picker disabled v-model="AuthorizeChainViewModel.endDate" type="date" style="width:150px" placeholder="选择结束日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item>
                        <el-checkbox disabled v-model="AuthorizeChainViewModel.longTime">长期</el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="授权产品" prop="productName">
                        <el-select ref="productSelect" disabled v-model="productNameList" multiple filterable style="width: 100%" placeholder="请选择">
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-form v-for="(item,index) in AuthorizeChainViewModel.details" :key="index" :model="item.details" label-width="80px" style="border: 1px solid #00000028; padding: 10px; margin-top: 10px">
            <el-row>
                <el-col :span="24">
                    <span style="color: #168eff; font-size: 18px">{{ numberToChinese(index+1)  }}级授权</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="发起企业" prop="name">
                        <el-input disabled v-model="item.name" style="width:300px" placeholder="请输入发起企业"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="目标企业" prop="supplierId">
                        <!-- <el-select disabled v-model="item.supplierId" style="width: 100%" @focus="targetFocusEvt(index)" @change="produceEvt" :filter-method="getProductList" filterable placeholder="请选择" :style="{ width: '280px' }">
                            <el-option v-for="i in STATIC_Suppliers" :key="i.id" :label="i.name" :value="i.id">
                            </el-option>
                        </el-select> -->

                        <el-select disabled v-model="item.supplierName" style="width: 100%" filterable placeholder="请选择" :style="{ width: '280px' }">
                            <el-option v-for="i in STATIC_Suppliers" :key="i.id" :label="i.name" :value="i.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="授权期限" required>
                        <el-date-picker disabled v-model="item.startDate" type="date" style="width:150px" placeholder="选择开始日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                        -
                        <el-date-picker disabled v-model="item.endDate" type="date" style="width:150px" placeholder="选择结束日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                        <!-- <el-date-picker v-model="item.value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @focus="focusDateEvt(index)" @change="dateEvt">
                            </el-date-picker> -->
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item>
                        <el-checkbox disabled v-model="item.longTime">长期</el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="授权书" prop="fileInfos">
                        <el-popover style="width:50%" placement="bottom" width="360" trigger="click">
                            <ul class="fileListUl_always">
                                <li class="fileItem" v-for="(i, k) in item.fileInfos" :key="k">
                                    <span class="fileName">{{ i.name }}</span>
                                    <div class="btn_group canedit">
                                        <span v-preventReClick @click="privewImg(i)">
                                            点击查看
                                        </span>

                                    </div>
                                </li>
                            </ul>
                            <span slot="reference" class="show-files">
                                查看附件
                            </span>
                        </el-popover>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div slot="footer" class="dialog-footer">

            <el-button class="btn primary" v-if="ApprovalBtn" type="primary" size="small" @click="ApprovalEvt(3)">同 意</el-button>
            <el-button class="btn" v-if='ApprovalBtn' size="small" @click="ApprovalEvt(4)">拒 绝</el-button>
            <el-button class="btn" size="small" @click="bindingClose">取 消</el-button>
            <el-button class="btn primary" v-if="!ApprovalBtn" type="primary" size="small" @click="bindingClose">确 定</el-button>
        </div>
    </el-dialog>

    <el-image-viewer :openViewer="dialogVisible" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" />
</div>
</template>

<script>
import {
    GetAuthorizechains,
    GetAuthorizechainById,
    RemoveAuthorizechains,
    ApproveAuthorizechain

} from "@/api"
import GetDataMixin from "@/mixin/getData-mixin.js"
import SelectFilter from "@/components/table-select-filter"
import ElImageViewer from "@/components/elImageViewer";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
export default {
    mixins: [GetDataMixin, GetDataSpdMixin],
    components: {
        SelectFilter,
        ElImageViewer,
    },
    data() {
        return {
            // 查询条件
            query: {
                keyWord: "",
                pageSize: 10,
                pageIndex: 1,
                type: '1'
            },
            tableDataIndex:0,
            // 列表数据
            tableData: [],
            // 列表总数
            total: 0,
            // 弹出框标题
            title: "",
            filterOptions: [{
                    name: "生产厂家",
                    type: "select",
                    code: "manufacturerId",
                    filterMethod: this.getManufacturers,
                    data: []
                },
                {
                    name: "供应商",
                    type: "select",
                    code: "supplierId",
                    filterMethod: this.getSuppliers1,
                    data: []
                },
                {
                    name: "授权链编号",
                    type: "input",
                    code: "keyWord",
                },
                {
                    name: "授权期限",
                    type: "date",
                    code: "date",
                },
                {
                    name: "效期类型",
                    type: "select",
                    code: "overdueState",
                    data: [{
                            name: "正常",
                            id: 1,
                        },
                        {
                            name: "即将过期",
                            id: 2,
                        },
                        {
                            name: "已过期",
                            id: 3,
                        },
                    ],
                },
                {
                    name: "产品名称",
                    type: "select",
                    code: "productId",
                    filterMethod: this.getProductsNoDebounce,
                    data: []
                },
                {
                    name: "规格型号",
                    type: "select",
                    code: "specId",
                    filterMethod: this.getSpecs,
                    data: []
                },

            ],
            activeName: '1',
            show: false,
            viewRow: {},
            viewList: [],
            AuthorizeChainViewModel: {
                details: [{}]
            },
            productNameList: [],
            dialogVisible: false,
            dialogImageUrl: "",
            fileName: "",
            fileId: 0,
            ApprovalBtn: false,

        };
    },
    
    mounted() {
         this.getManufacturers()
        this.getData();
        if (this.$route.query.showApproval) {
            this.viewEvt(this.$route.query, 2)
            this.query.type = '0'
        }
    },
    methods: {
        filterChange() {
            this.getData()
        },
        // 获取列表
        getData() {
            // this.tableData.push({})
            GetAuthorizechains(this.query).then(res => {
                this.tableData = res.returnData.data

            })

        },
        //查看
        viewEvt(row, num) {
            this.viewRow = row
            // GetAuthorizechainById
            GetAuthorizechainById({
                id: row.id
            }).then(res => {
                if (!res.returnData) {
                    return
                }
                this.AuthorizeChainViewModel = res.returnData
                this.AuthorizeChainViewModel.longTime = res.returnData.longTime == 1 ? true : false
                this.AuthorizeChainViewModel.details = res.returnData.details.map(res => {
                    res.longTime = res.longTime == 1 ? true : false
                    return res
                })
                this.AuthorizeChainViewModel.productName = res.returnData.products.map(res => {
                    return `${res.name} ${res.specName}`
                })
                this.productNameList = this.AuthorizeChainViewModel.productName
                if (num == 2) {
                    this.ApprovalBtn = true
                } else {
                    this.ApprovalBtn = false
                }
                this.show = true
            })

        },
        deleteEvt(row) {
            this.$confirm(
                    '删除后将无法恢复，请谨慎操作。',
                    "确定要删除吗?", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }
                )
                .then(() => {
                    RemoveAuthorizechains({
                        ids: [row.id]
                    }).then(() => {
                        this.getData();
                        this.msgSuccess("删除成功");
                    })
                })

                .catch(function () {});
        },
        handleClick(tab, event) {
            if (this.tableDataIndex == tab.index) {
                this.$set(this.query, "pageIndex", 1);
                this.$set(this.query, "pageSize", 10);
                this.getData()
            } else {
                this.query.type = tab.index
                this.reset()
                this.getData()
            }
            this.tableDataIndex = tab.index 
        },
        // 改变当前页
        changePage(val) {
            this.$set(this.query, "pageIndex", val);
            this.getData();
        },
        handleSizeChange(val) {
            this.$set(this.query, "pageSize", val);
            this.getData();
        },

        // 重置
        reset() {
            this.query = {
                type: this.query.type,
                orgCode :sessionStorage.getItem('orgId')
            }
            this.query.keyWord = "";
            this.$set(this.query, "pageIndex", 1);
            this.$set(this.query, "pageSize", 10);
            this.ids = []
            this.multipleSelection = []
            this.multiple = true;

            if (this.$refs.multipleTable) {
                this.$refs.multipleTable.clearSelection()
            }
            this.getData();
        },

        queryChange() {
            this.$set(this.query, "pageIndex", 1);
            this.getData();
        },
        bindingClose() {
            this.show = false
        },
        numberToChinese(num) {
            const chineseNums = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
            return chineseNums[num - 1];
        },
        privewImg(file) {
            // this.dialogImageUrl = file.path;
            // this.dialogVisible = true;
            this.dialogVisible = true;
            this.fileId = file.id;
            this.fileName = file.name;
        },
        closeImageViewer() {
            this.dialogVisible = false;
        },
        ApprovalEvt(num) {
            ApproveAuthorizechain({
                id: this.AuthorizeChainViewModel.id,
                state: num,
            }).then(res => {
                this.show = false
            })

        }
    },

};
</script>

<style lang="scss" scoped>
/deep/.el-badge__content.is-fixed {
    top: 10px !important;
    right: 16px !important;
}

/deep/.el-tabs--top .el-tabs__item.is-top:last-child,
.el-tabs--top .el-tabs__item.is-bottom:last-child,
.el-tabs--bottom .el-tabs__item.is-top:last-child,
.el-tabs--bottom .el-tabs__item.is-bottom:last-child {
    padding-right: 20px !important;
}
</style>
